/**
 * CalendarWidget Component
 *
 * Виджет календаря для карточки организации.
 * Отображает события (встречи, звонки, МК) конкретной организации.
 */

import React from 'react';
import { IconCalendar } from '@tabler/icons-react';
import BaseWidget from './BaseWidget';
import Calendar from '../../Calendar/Calendar';

const CalendarWidget = ({ organization }) => {
  return (
    <BaseWidget
      title="Календарь"
      icon={IconCalendar}
      defaultExpanded={true}
      collapsible={true}
    >
      <Calendar organizationId={organization?.id} />
    </BaseWidget>
  );
};

export default CalendarWidget;
